export default __webpack_public_path__ + "static/media/vrLogo.dae52043.jpeg";